const FIRST_LEG_DELIVERY_ROUTES = [
  {
    path: 'first-leg/shipping-plan',
    name: 'firstLegShippingPlan',
    component: () => import('@/views/first-leg-delivery/shipping-plan/index'),
    meta: {
      title: '发货计划单',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'first-leg/shipping-notice',
    name: 'firstLegShippingNotice',
    component: () => import('@/views/first-leg-delivery/shipping-notice/index'),
    meta: {
      title: '发货通知单',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'first-leg/dg-delivery',
    name: 'firstLegDgDelivery',
    component: () => import('@/views/first-leg-delivery/dg-delivery/index'),
    meta: {
      title: '东莞仓送货单',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'first-leg/invoice',
    name: 'firstLegInvoice',
    component: () => import('@/views/first-leg-delivery/invoice/index'),
    meta: {
      title: '发货单',
      icon: '',
      keepAlive: true,
    },
  },
]
export default FIRST_LEG_DELIVERY_ROUTES
